import { AppStoreContextWrapper, RouteContext } from '@common/contexts';
import { useDataDog } from '@common/hooks';
import { AuthApplicationKeys } from '@common/models/Enums';
import { AppStore } from '@common/stores';
import { buildAppRoute } from '@customer/components/routes';
import { AppLandingOutlet } from '@customer/views/.';
import { datadogRum } from '@datadog/browser-rum';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { ErrorBoundary } from './views/error/ErrorBoundary';

const appStore = new AppStore(AuthApplicationKeys.PetPass, true); //todo change to key for customer app
AppStoreContextWrapper.set(appStore);
appStore.load();

//This is a separate component to prevent calling buildAppRoute before the configurationStore is in a loaded state
//this prevents needing complex reactions in stores that depend on the configuration being in a loaded state.
const RoutesComponent = observer(() => {
    const appRoutes = buildAppRoute(appStore);
    RouteContext.set(appRoutes);
    return useRoutes(appRoutes);
});

export const CustomerApp = observer(() => {
    const location = useLocation();
    useDataDog({ service: 'petpass-customer-app-react' });

    const [route, setRoute] = useState({
        to: location.pathname,
        from: location.pathname
    });

    useEffect(() => {
        setRoute((prev) => ({ to: location.pathname, from: prev.to }));

        datadogRum.addAction('route_change', {
            path: location.pathname,
            search: location.search,
            hash: location.hash,
        });

        datadogRum.startView(location.pathname);
    }, [location]);

    return (
        <ErrorBoundary route={route}>
            {
                !appStore.isConfigurationLoading ? <RoutesComponent /> : <AppLandingOutlet />
            }
        </ErrorBoundary>
    );
});

export default CustomerApp;
